module.exports = __webpack_public_path__ + "static/img/22.374e1e35.png";